export default __webpack_public_path__ + "static/media/mx.7a366c4d.svg";